import { FC } from "react";
import { ICandidate } from "../../../../store/centers/types";
import { getFormatedDate } from "../../../../utils/dataParser";
import { capitalizeName } from "../../../../utils/stringUtils";
import PopupModal from "../../../UI/Popup";

interface IBlockReasonProps {
  showBlockReasonModal: boolean;
  onClickClose: () => void;
  getCandidateDetails: ICandidate | null;
}

const BlockReason: FC<IBlockReasonProps> = ({
  showBlockReasonModal,
  onClickClose,
  getCandidateDetails,
}) => {
  return (
    <>
      <PopupModal
        visible={showBlockReasonModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
        customWidth={650}
      >
        <div className="d-flex flex-column gap-20">
          <div className="d-flex flex-column gap-15">
            <div className="fs-22 fw-400 text-black">
              Blocked: {capitalizeName(getCandidateDetails?.first_name || "")}{" "}
              {capitalizeName(getCandidateDetails?.last_name || "")}
            </div>
            <div className="d-flex flex-column gap-8">
              <div className="fs-13 fw-400 text-black">
                Blocking a candidate will mean your centres will not be visible
                to them and they may not apply or accept your vacancies.
              </div>
              <div className="fs-13 fw-400 text-black">
                Candidates will not be notified when they are blocked.
              </div>
            </div>
            <div className="bg-teal-pale border border-teal-dark p-20px radius-8px d-flex flex-column gap-10">
              <div className="fs-13 fw-400 text-teal-dark">
                {getFormatedDate(getCandidateDetails?.blocked_date ?? "")}
              </div>
              <div className="fs-16 fw-700 text-teal-dark">
                {capitalizeName(getCandidateDetails?.blocked_by_first_name || "") +
                  " " +
                  getCandidateDetails?.blocked_by_last_name}{" "}
                has submitted the below reason:
              </div>
              <div className="fs-16 fw-400 text-black">
                {getCandidateDetails?.blocked_reason ? getCandidateDetails?.blocked_reason : "No reason entered"}
              </div>
            </div>
          </div>
        </div>
      </PopupModal>
    </>
  );
};

export default BlockReason;
